<script lang="ts">
  import { Col } from "sveltestrap";
  import { Copyhighlightedtext, Copypara, CopyPortionFromParagraph, dolorsitamet, Loremipsum } from "../../../../utils/Constant/Constant";
  import { copy } from 'svelte-copy';
  import Card from "../../../Core/Card.svelte";
  let selectValue:string = "dolor sit amet"
</script>
<Col sm="12" md="6">
    <Card headerTitle={CopyPortionFromParagraph} cardHeaderprops="pb-0">
      <div slot="contentbody">
        <div class="clipboaard-container">
          <p class="card-description">{CopyPortionFromParagraph}</p>
          <h6 class="border rounded card-body f-w-300">{Loremipsum} 
            <span class="bg-primary text-white p-1" id="clipboardExample4">{dolorsitamet}</span>{Copypara}
          </h6>
          <div class="mt-3">
            <button class="btn btn-primary btn-clipboard" use:copy={selectValue}>
              <i class="fa fa-copy"></i> {Copyhighlightedtext}
            </button>
          </div>
        </div>
      </div>
    </Card>
</Col>